module.exports = __webpack_public_path__ + "static/flags/UV-6404cb5b6931e208e3c3c0ab83504624.gif";